export const PackingMaterialPricesColumns = [
    "SNo",
    "Product",
    "PackStyle",
    'Price', 

  
]